/* PGJ catalog builder: turns Shopify product records (products.json shape) into the catalog objects the theme uses.
   Shared by the browser (assets/live-sync.js) and the build script (go-live/tools/build-live-catalog.cjs).
   Tag convention for the team (set on the product in Shopify admin):
     kondisi:bnib | kondisi:bnob | kondisi:preowned     (no tag = BNIB)
     grade:excellent | grade:very-good | grade:like-new  (pre-owned only)
     tahun:2023                                          (pre-owned only)
     showroom                                            (ready at the PIK 2 showroom)
   Photo convention: a product image whose alt text contains pgj-packshot / pgj-wrist / pgj-alt overrides the
   theme crop for that slot, so clean photos can be added later without touching the theme. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(); else root.PGJCatalogBuilder = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  var BRANDS = [
    ['TAG HEUER', 'TAG Heuer', 'swiss'], ['MAURICE LACROIX', 'Maurice Lacroix', 'swiss'],
    ['TISSOT', 'Tissot', 'swiss'], ['ORIS', 'Oris', 'swiss'], ['BREITLING', 'Breitling', 'swiss'],
    ['IWC', 'IWC Schaffhausen', 'swiss'], ['BELL & ROSS', 'Bell & Ross', 'swiss'], ['SEIKO', 'Seiko', 'japan'],
    ['SALVATORE FERRAGAMO', 'Salvatore Ferragamo', 'fashion'], ['VERSACE', 'Versace', 'fashion'],
    ['BONEST GATTI', 'Bonest Gatti', 'fashion'], ['LUCKY HARVEY', 'Lucky Harvey', 'fashion'], ['LE JOUR', 'Le Jour', 'fashion']
  ];
  var DIAL_COLORS = [
    ['Ice Blue', /ice blue|light blue|sky blue|turquoise|tiffany/i], ['Mother of Pearl', /mother.of.pearl|\bmop\b/i],
    ['Skeleton', /skeleton|openwork|transparent dial/i], ['Blue', /blue|navy|biru/i], ['Green', /green|hijau/i],
    ['Red', /red|burgundy|bordeaux|merah/i], ['Orange', /orange/i], ['Brown', /brown|chocolate|coklat|bronze/i],
    ['Grey', /grey|gray|anthracite|slate|abu/i], ['White', /white|putih|ivory|cream/i], ['Silver', /silver/i],
    ['Gold', /gold|champagne|yellow/i], ['Pink', /pink|rose dial|salmon/i], ['Black', /black|hitam/i]
  ];
  var SWATCH = { 'Ice Blue': '#A9D8E6', 'Mother of Pearl': '#EDE6EA', Skeleton: '#7C7C7C', Blue: '#1F3E7A', Green: '#1F6B45', Red: '#9E1B22', Orange: '#E0692A', Brown: '#6B4426', Grey: '#6E7378', White: '#F3F1EC', Silver: '#C9CCD0', Gold: '#C9A452', Pink: '#E7B9B4', Black: '#151515' };
  var GRADE = { excellent: 'Excellent', 'very-good': 'Very Good', 'like-new': 'Like New' };
  var FALLBACK_D = [[/gentleman/i, 40], [/t-race/i, 45], [/fiaba square/i, 28], [/fiaba/i, 32], [/prx 25/i, 25]];

  function slug(s) { return s.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function text(html) {
    return String(html || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n').replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&#39;/g, "'").replace(/&quot;/g, '"')
      .replace(/[⁠​]/g, '').replace(/ /g, ' ');
  }
  function parse(p) {
    var lines = text(p.body_html).split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
    var spec = {}, lists = { kelengkapan: [], kondisi: [] }, mode = null, intro = [], seenSpec = false;
    lines.forEach(function (l) {
      if (/^spesifikasi\s*:?$/i.test(l)) { seenSpec = true; mode = null; return; }
      if (/^kelengkapan\s*:?$/i.test(l)) { mode = 'kelengkapan'; return; }
      if (/^kondisi\s*:?$/i.test(l)) { mode = 'kondisi'; return; }
      if (/^(info pgj|catatan penting|jam operasional)/i.test(l)) { mode = 'skip'; return; }
      if (!seenSpec) { intro.push(l); return; }
      if (mode === 'skip') return;
      if (mode && /^[•\-\d]/.test(l)) { lists[mode].push(l.replace(/^[•\-\d.\s]+/, '').trim()); return; }
      var m = l.match(/^([A-Za-z][A-Za-z /()&]{1,30}?)\s*:\s*(.+)$/);
      if (m && !spec[m[1].trim()]) spec[m[1].trim()] = m[2].trim();
    });
    return { spec: spec, lists: lists, intro: intro };
  }

  function conditionFromTags(tags) {
    var lc = (tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
    function first(re) { for (var i = 0; i < lc.length; i++) { var m = lc[i].match(re); if (m) return m; } return null; }
    var c = first(/^kondisi:(bnib|bnob|pre-?owned)$/);
    var cond = c ? (c[1] === 'bnib' ? 'BNIB' : c[1] === 'bnob' ? 'BNOB' : 'Pre-owned') : 'BNIB';
    var g = first(/^grade:([a-z-]+)$/), y = first(/^tahun:(\d{4})$/);
    return { cond: cond, grade: cond === 'Pre-owned' ? (g && GRADE[g[1]]) || null : null, year: cond === 'Pre-owned' && y ? +y[1] : null, show: lc.indexOf('showroom') > -1 };
  }

  // photos tagged through the image alt text (future clean photography)
  function taggedPhotos(p) {
    var out = {};
    (p.images || []).forEach(function (im) {
      var m = String(im.alt || '').toLowerCase().match(/pgj-(packshot|wrist|alt)/);
      if (m && !out[m[1]]) out[m[1]] = String(im.src).split('?')[0] + '?width=900';
    });
    return out;
  }

  /* opts.crop(id, suffix) -> theme crop path or null.  opts.badWrist: array of ids whose wrist crop is unusable. */
  function build(products, opts) {
    opts = opts || {}; var crop = opts.crop || function () { return null; }; var bad = {};
    (opts.badWrist || []).forEach(function (id) { bad[id] = 1; });
    var out = products.map(function (p) {
      var T = String(p.title).replace(/‑/g, '-'), up = T.toUpperCase();
      var b = null; for (var i = 0; i < BRANDS.length; i++) if (up.indexOf(BRANDS[i][0]) === 0) { b = BRANDS[i]; break; }
      b = b || ['', p.vendor, 'fashion'];
      var brand = b[1], pr = parse(p), spec = pr.spec, lists = pr.lists;
      var vs = p.variants || [];
      var v = vs.slice().sort(function (x, y) { return +x.price - +y.price; })[0] || {};
      var price = Math.round(+v.price || 0), cmp = Math.round(+v.compare_at_price || 0);
      var compare = cmp > price ? cmp : 0; // strike-through only when the store really has a higher price
      var ref = (spec['Reference Number'] || spec['Model / Ref'] || (T.match(/[-–]\s*([A-Z0-9][A-Z0-9.\-/ ]{4,})$/) || [])[1] || '').trim();
      var name = T.slice(b[0].length).replace(/\s*[-–]\s*[A-Z0-9][A-Z0-9.\-/ ]{4,}$/, '').trim().replace(/^[-–\s]+/, '');
      if (!name) name = T;
      function all(k) { return spec[k] || ''; }
      var dm = [all('Diameter Case'), all('Case'), T, text(p.body_html)].map(function (s) { return (s.match(/(\d{2}(?:[.,]\d)?)\s*mm/i) || [])[1]; }).filter(Boolean)[0];
      var fb = FALLBACK_D.filter(function (r) { return r[0].test(T); })[0];
      var diameter = dm ? parseFloat(dm.replace(',', '.')) : (fb ? fb[1] : null);
      var movementTxt = all('Movement');
      var mv = /quartz/i.test(movementTxt) ? 'Quartz' : /solar|eco.?drive/i.test(movementTxt) ? 'Solar' : /manual|hand.?wound/i.test(movementTxt) ? 'Manual' : /automat|powermatic|calibre|caliber|self/i.test(movementTxt) ? 'Automatic' : (/automatic/i.test(T) ? 'Automatic' : 'Quartz');
      var dialTxt = all('Dial Color') || all('Dial') || T;
      var dialColor = (DIAL_COLORS.filter(function (d) { return d[1].test(dialTxt); })[0] || DIAL_COLORS.filter(function (d) { return d[1].test(T); })[0] || ['Black'])[0];
      var wrm = [all('Water Resistance'), all('Water Resistant'), text(p.body_html)].map(function (s) { return (s.match(/(\d{2,4})\s*(?:m|meter|M\s*\/)/i) || [])[1]; }).filter(Boolean)[0];
      var wr = wrm ? parseInt(wrm, 10) : null;
      var strapTxt = all('Strap') || all('Bracelet') || all('Strap/Band');
      var strap = /bracelet|stainless|steel|titanium bracelet|gelang|mesh/i.test(strapTxt) && !/rubber|leather|kulit|textile|nato|fabric/i.test(strapTxt) ? 'Bracelet'
        : /rubber|karet|silicone/i.test(strapTxt) ? 'Rubber' : /leather|kulit|alligator/i.test(strapTxt) ? 'Leather'
          : /textile|nato|fabric|nylon/i.test(strapTxt) ? 'Textile' : /ceramic/i.test(strapTxt) ? 'Ceramic' : 'Bracelet';
      var caseTxt = all('Material Case') || all('Case');
      var caseMat = /titanium/i.test(caseTxt) ? 'Titanium' : /ceramic/i.test(caseTxt) ? 'Ceramic' : /bronze/i.test(caseTxt) ? 'Bronze'
        : /carbon/i.test(caseTxt) ? 'Carbon' : /gold|pvd|plated|two.?tone|rose/i.test(caseTxt) ? 'Two-tone / PVD' : 'Stainless Steel';
      var fn = all('Functions'), isChrono = /chrono/i.test(fn + T);
      var isDive = /seastar|aquaracer|superocean|aquis|diver|pontos s diver|seacolt|ocean|br 03.?92|hydroconquest/i.test(T) || (wr && wr >= 300);
      var isRace = /formula 1|t-race|carrera|indy|racing|monaco/i.test(T);
      var isDress = /ballade|gentleman|les classiques|fiaba|eliros|classic|dress|everytime|t-classic/i.test(T) || (strap === 'Leather' && !isChrono);
      var style = isDive ? 'Diver' : isRace ? 'Racing' : isChrono ? 'Chronograph' : isDress ? 'Dress' : 'Sport';
      var gender = diameter && diameter <= 34 ? 'Wanita' : diameter && diameter <= 38 ? 'Unisex' : 'Pria';
      var ct = conditionFromTags(p.tags);
      var series = all('Series') || name.split(' ').slice(0, 2).join(' ');
      var all12 = (p.images || []).slice(0, 12).map(function (i) { return String(i.src).split('?')[0]; });
      var imgs = all12.map(function (u) { return u + '?width=900'; });
      var a = null, c = null, bw = null, tp = taggedPhotos(p); // store photos only; no theme crops
      var boxList = lists.kelengkapan.filter(function (x) { return !/tahun|garansi movement/i.test(x) && x.length < 40; }).slice(0, 6);
      var calm = movementTxt.match(/(Powermatic \d+|Calibre [\w-]+|Caliber [\w-]+|ML\d+|Oris \d+|B\d{2}|Sellita [\w-]+|ETA [\w.-]+|Miyota [\w-]+|NH\d+\w?|Seiko \w+|\b\d{4}\b)/i);
      var img = tp.packshot || imgs[0] || null;
      return {
        sn: name.replace(/\s*Stainless Steel/ig, '').replace(/\s+(Automatic|Quartz)$/i, '').replace(/\s{2,}/g, ' ').trim(),
        id: p.id, vid: v.id || null, h: p.handle, brand: brand, bs: slug(brand), cls: b[2], name: name, series: series, ref: ref, price: price, compare: compare,
        d: diameter, mv: mv, mvTxt: movementTxt, cal: calm ? calm[0] : '',
        pr: all('Power Reserve'), dial: dialTxt, dc: dialColor, sw: SWATCH[dialColor], wr: wr, strap: strap, strapTxt: strapTxt, caseMat: caseMat, caseTxt: caseTxt,
        bezel: all('Bezel'), crystal: all('Crystal'), fn: fn, back: all('Caseback'), th: all('Thickness') || all('Ketebalan'),
        buckle: all('Buckle') || all('Clasp'), lug: all('Lug Width'), l2l: all('Lugs Distance'), hands: all('Hands'), markers: all('Markers'),
        ph: tp.packshot || tp.wrist || tp.alt ? 'tagged' : 'store',
        style: style, gender: gender, cond: ct.cond, grade: ct.grade, year: ct.year, war: 'PGJ', show: ct.show,
        box: boxList.length ? boxList : ['Box', 'Kartu Garansi', 'Buku Manual'],
        intro: pr.intro.slice(0, 3),
        img: img,
        img2: tp.wrist || imgs[1] || imgs[0] || null,
        img3: tp.alt || imgs[2] || imgs[1] || null,
        imgs: all12.map(function (u) { return u + '?width=1400'; }),
        src: imgs.slice(0, 2).map(function (u) { return u.split('?')[0]; }), created: p.created_at,
        avail: vs.some(function (x) { return x.available; })
      };
    });
    out.sort(function (x, y) { return String(y.created).localeCompare(String(x.created)); });
    return out;
  }
  return { build: build, conditionFromTags: conditionFromTags };
});
